export const getSelectedAccount = accountsState => {
    const selectedAccounts = accountsState.accounts.filter(account => account.key === accountsState.selectedAccount)
    if (selectedAccounts.length > 0) {
        return selectedAccounts[0]
    }
    return null
}

export default getSelectedAccount